import styled from "styled-components";

const HomeDivContainer = styled.div`
  height: ${(props) => props.divStyle.height || "100vh"};
  background: ${(props) => props.divStyle.background || "none"};
`;

export { HomeDivContainer };
